import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MasterComponent, MasterDetailComponent, PanelComponent, TitleComponent } from '@rocksoft/cdk';
import { GroupsPermissionsEntityListContainerComponent } from './groups-permissions-entity-list.container';

@Component({
  selector: 'era-security-groups-permissions-view',
  templateUrl: './groups-permissions-view.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MasterDetailComponent,
    MasterComponent,
    PanelComponent,
    TitleComponent,
    GroupsPermissionsEntityListContainerComponent,
  ],
})
export class GroupsPermissionsViewContainerComponent {}
